<template>
    <v-data-table
        :headers="headers"
        :items="stationLocations"
        :loading="loading"
        show-expand
        :expanded.sync="expanded"
        :items-per-page="999999"
        item-key="id"
        loading-text="Loading station locations"
        class="elevation-0"
        group-by="type"
        group-key="type"
        hide-default-footer
    >
        <template v-slot:group.header="{ group, headers, toggle, isOpen }">
            <td :colspan="headers.length" class="pl-1 font-weight-bold">
                <v-btn :ref="group" :data-open="isOpen" icon small @click="toggle">
                    <v-icon v-if="isOpen">mdi-chevron-down</v-icon>
                    <v-icon v-else>mdi-chevron-up</v-icon>
                </v-btn>
                {{ group.charAt(0).toUpperCase() + group.slice(1) }}
            </td>
        </template>
        <template v-slot:expanded-item="{ item }">
            <td :colspan="headers.length + 1" class="px-0 pl-4">
                <CompaniesListStationLocationUser :users="item.users"/>
            </td>
        </template>
        <template v-slot:item.users_count="{ item }">
            {{ item.users.length }}
        </template>
        <template v-slot:item.actions="{ item }">
            <v-row justify="center" class="min-width-115 action-buttons">

                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn @click="openGraphs(item)" small color="primary" icon v-on="on">
                            <v-icon>mdi-chart-bell-curve-cumulative</v-icon>
                        </v-btn>
                    </template>
                    <span>Graph</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            @click="openStationLocation(item)"
                            @click.middle.exact="openStationLocation(item)"
                            small
                            color="primary"
                            icon
                            v-on="on"
                        >
                            <v-icon>mdi-open-in-new</v-icon>
                        </v-btn>
                    </template>
                    <span>Details</span>
                </v-tooltip>
            </v-row>
        </template>
    </v-data-table>
</template>
<script>
import { mapActions } from 'vuex';
import CompaniesListStationLocationUser from './CompaniesListStationLocationUser.vue';

export default {
    name: 'CompaniesListStationLocation',
    components: {CompaniesListStationLocationUser},
    props: {
        company: {type: Object, required: true},
    },
    data() {
        return {
            expanded: [],
            headers: [
                {
                    text: 'ID',
                    align: 'start',
                    sortable: false,
                    value: 'id',
                },
                {
                    text: 'Probe',
                    align: 'start',
                    sortable: false,
                    value: 'probe_alias',
                },
                {
                    text: 'Long alias',
                    align: 'start',
                    sortable: false,
                    value: 'long_alias',
                },
                {
                    text: 'Start date',
                    align: 'start',
                    sortable: false,
                    value: 'start_date',
                },
                {
                    text: 'End date',
                    align: 'start',
                    sortable: false,
                    value: 'end_date',
                },
                {
                    text: 'Region',
                    align: 'start',
                    sortable: false,
                    value: 'region',
                },
                {
                    text: 'Country',
                    align: 'start',
                    sortable: false,
                    value: 'country_code',
                },
                {
                    text: 'Users',
                    align: 'start',
                    sortable: false,
                    value: 'users_count',
                },
                {
                    text: '',
                    align: 'end',
                    sortable: false,
                    value: 'actions',
                },
            ],
        };
    },
    computed: {
        stationLocations: function() {
            if (!this.company || !this.company.station_locations) {
                return [];
            }

            return this.company.station_locations;
        },
        loading: function() {
            return !(this.company && this.company.id);
        },
    },
    methods: {
        ...mapActions('company', ['fetchCompanyStationLocations']),

        openGraphs(location) {
            let url = new URL(`${process.env.VUE_APP_APP_URL}/graph-v2/${location.id}`);
            window.open(url, '_blank');
        },

        openStationLocation(location) {
            const path = this.$router.resolve({
                name: 'station-location',
                params: {probeId: location.station_id, locationId: location.id},
            });
            return window.open(path.href, '_blank');
        },
    },
};
</script>


<style scoped>
</style>